import React from "react";

export const DoubleLine = ({ title, text,
                               fontColor='var(--font-color-1)',
                               maxLength = 40,
                               titleSize='1.1em',
                               textSize='0.95em',
                               noGap=false,
                                 wrapText=true
}) => {
    // Utility function to truncate text based on maxLength
    let truncateText = (_text) => {
        // Check if text needs to be truncated
        if (_text?.length > maxLength) {
            return `${_text?.substring?.(0, maxLength)}..`; // Truncate and append ellipsis
        }
        return _text; // Return original text if no truncation is needed
    };
    const titleStyle = {
        fontSize: titleSize,
        fontWeight: '400',
        color: fontColor

    }
    const textStyle = {
        fontSize: textSize,
        fontWeight: '300',
        color: fontColor,
        whiteSpace: wrapText ? 'normal' : 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    }
    let containerStyle = {
        display: 'flex',
        flexDirection: 'column'
    }
    if (noGap){
        containerStyle.lineHeight = '1';
    }
    return (
        <div style={containerStyle}>
            <span style={titleStyle}>{truncateText(title)}</span>
            <span style={textStyle}>{truncateText(text)}</span>
        </div>
    );
}
